import React, { useState } from 'react';
import { Grid, Button } from '@material-ui/core';
import dashedButtonStyle from 'styles/buttons/dashed-button.module.scss';
import AddIcon from '@material-ui/icons/Add';
import { TestimonialsDialog } from './testimonials-dialog';
import { useSelector } from 'react-redux';
import { GetUrlBuilderData } from 'store/url-builder';
import { TestimonialCarousel } from './testimonial-carousel';

export interface TestimonialsProps {
 maxTestimonials?: number;
 builderType: string;
 readonly?: boolean;
}

export const Testimonials = ({ maxTestimonials = 5, builderType, readonly = false }: TestimonialsProps) => {
 const [dialog, setDialog] = useState(false);
 const builderData = useSelector(GetUrlBuilderData);

 const openDialog = () => {
  setDialog(true);
 };

 const handleDialogClose = () => setDialog(false);
 return (
  <Grid item container xs={12}>
   {builderData.testimonials.length > 0 && (
    <Grid item xs={12} style={{ paddingBottom: '2em' }}>
     <TestimonialCarousel testimonials={builderData.testimonials} color={builderData.primaryColor.color} cardId={builderData.cardId} builderType={builderType} readonly={readonly}/>
    </Grid>
   )}
   {builderData.testimonials.length < maxTestimonials && !readonly && (
    <Grid item xs={12}>
     <Button onClick={openDialog} classes={{ root: dashedButtonStyle.root }} fullWidth>
      <AddIcon /> Add Testimonial
     </Button>
    </Grid>
   )}
   {dialog && <TestimonialsDialog isOpen={dialog} onClose={handleDialogClose} builderType={builderType}/>}
  </Grid>
 );
};
